export const styleSheet = () => ({
    tooltipClone: {
        maxWidth: 290,
        opacity: 1
    }
});
